document.addEventListener("DOMContentLoaded", function() {
  const navItems = document.querySelectorAll('.custom-slideshow-nav-item');
  const slides = document.querySelectorAll('.custom-slideshow-slide');
  let currentIndex = 0;
  let autoRotateInterval;

  const showSlide = (index) => {
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
    navItems.forEach((nav, i) => {
      nav.classList.toggle('active', i === index);
    });
    currentIndex = index;
  };

  const startAutoRotate = () => {
    autoRotateInterval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    }, 4000);
  };

  const stopAutoRotate = () => {
    clearInterval(autoRotateInterval);
  };

  showSlide(currentIndex);
  startAutoRotate();

  navItems.forEach((item, i) => {
    item.addEventListener('click', () => {
      stopAutoRotate();
      showSlide(i);
      startAutoRotate();
    });
  });
})